var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.025,
    height: 32.586,
    viewBox: "0 0 27.025 32.586",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "map-pin_1_",
    "data-name": "map-pin(1)",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_389",
    "data-name": "Path 389",
    d: "M28.025,13.512c0,9.732-12.512,18.073-12.512,18.073S3,23.244,3,13.512a12.512,12.512,0,1,1,25.025,0Z",
    transform: "translate(-3 -1)",
    fill: "#e6f3fe",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(8.025 7.697)",
    fill: "#e6f3fe",
    stroke: "#0182f0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationsIcon);
export default __webpack_public_path__ + "static/media/locations-icon.bd99ea14498920eb57c2f0db980eb1be.svg";
export { ForwardRef as ReactComponent };